import React, {useState, useEffect, useRef, useReducer} from "react"
import {NavLink} from "react-router-dom"
import './style.css'
import click from '../img/click.gif'

export const Welcome = () => {

    return (
        <form action="">
            <div className="main__wrapper">
                <div className="welcome__container">
                    <h1>КЛИКАЙ</h1>
                    <h2>ПОКУПАЙ</h2>
                    <h3>ИГРАЙ</h3>
                    <img src={click} alt=""/>
                </div>
                <div className="button__container">
                        <NavLink  className="border"
                            style={{
                                textDecoration: 'none'
                            }}
                            to={"/reg"}>
                            <p>Регистрация</p>
                        </NavLink>
               
           
                        <NavLink className="border"
                            style={{
                                textDecoration: 'none'
                            }}
                            to={"/log"}>
                            <p>Вход</p>
                        </NavLink>

                </div>
            </div>

        </form>
    )

}